import * as go from 'gojs';
import { sidebarConfig } from '../../config/config';
import { IS_SIDEBAR_TYPE_PROP } from '../common/config/common-prop-names';
import { angleBinding, locationBinding, lockedBindings, sizeBinding, zOrderBindings } from '../common/utils/bindings';
import { GROUP_NODE_MAIN_SHAPE_NAME } from './config/part-names';

const $ = go.GraphObject.make;
const movable = true;
const resizable = true;

const shape = () =>
  $(
    go.Shape,
    {
      figure: 'RoundedRectangle',
      stroke: sidebarConfig.colors.groupNode.borderColor,
      fill: sidebarConfig.colors.groupNode.backgroundColor,
      strokeWidth: 1,
      name: GROUP_NODE_MAIN_SHAPE_NAME,
    },
    sizeBinding(),
  );

const memberValidation = (thisGroup: go.Group, part: go.Part) => !!part.data[IS_SIDEBAR_TYPE_PROP];

export const groupNodeTemplate = () =>
  $(
    go.Group,
    go.Panel.Auto,
    {
      isLayoutPositioned: false,
      toolTip: null,
      resizeObjectName: GROUP_NODE_MAIN_SHAPE_NAME,
      resizable,
      movable,
      memberValidation,
    },
    shape(),
    angleBinding(),
    locationBinding(),
    ...lockedBindings({ movable, resizable }),
    ...zOrderBindings(),
  );
